export const getReportsAPIConfig = ({ reports }) => ({
    url: '/api/reports',
    method: 'POST',
    data: { reports },
});
